import { Loader, useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import {
    ViewModelForm,
    ViewModelServiceContext
} from '@xengage/gw-portals-viewmodel-react';
import { SuccessNotification } from 'gw-components-platform-react'; 
import _ from 'lodash';
import React, {
    useCallback,
    useContext,
    useEffect,
    useState,
} from 'react';
import { AgencyAdminService } from "twia-capability-agencyadmin";
import AddressSummary from '../AddressSummary/AddressSummary';
import messages from './OrgInfoTable.messages';
import metadata from './OrgInfoTable.metadata.json5';
import styles from './OrgInfoTable.module.scss';

function OrgInfoTable(props) {
    const { userVM, editPrimaryContact, editPrimaryLocationAddress, editMailingddress, editComissionsDirectDeposit } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const organization = userVM.organization_EXT;
    const primaryContact = organization.primaryPersonContact || organization.primaryCompanyContact;

    const translator = useTranslator();

    useEffect(() => { }, []);

    const editPrimaryContactDetails = useCallback(() => {
        editPrimaryContact();
    }, [editPrimaryContact]);


    const editPrimaryLocationAddressDetails = useCallback(() => {
        editPrimaryLocationAddress();
    }, [editPrimaryLocationAddress]);

    const editMailingAddressDetails = useCallback(() => {
        editMailingddress();
    }, [editMailingddress]);

    // US26488 It will enble direct deposit info conditionally 
    const editDirectDepositDetails = useCallback(() => {
        editComissionsDirectDeposit();
    }, [editComissionsDirectDeposit]);

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            phoneWide: {
                labelPosition: 'top',
            },
        },
        orgTitle: {
            content: organization.name.value   
        },
        licenseNumber: {
            content: translator(messages.licenseNumber).concat(organization.tdilicenseNumber.value)
        },
        primaryLocationTitle:{
            content: translator(messages.primaryLocation)
        },
        plAddresSummary: {
            address: organization.primaryLocationAddress_TWIA.value              
        },
        mailingAddressTitle:{
            content: translator(messages.mailingAddress)
        },
        mailingAddresSummary:{
            address: primaryContact.primaryAddress.value
        },
        primaryContactTitle:{
            content: translator(messages.primaryContact)
        },
        displayName:{
            content: primaryContact.displayName.value
        },
        emailAddress:{
            content: primaryContact.emailAddress1.value
        },
        workNumber:{
            value: primaryContact.workNumber?.value,
            readOnly: true
        },
        // mailingAddressDetails: {
        //     visible: organization.canEditPrimaryContact?.value
        // },
        // directDepositDetails: {
        //     visible: organization.canEditPaymentPreferences?.value
        // },
        // primaryContactDetails: {
        //     visible: organization.canEditPrimaryContact?.value
        // },
        directDepositTitle: {
            content: translator(messages.directDeposit)
        },
        accountNumber: {
            content: organization.paymentPreferences.accountNumber.value
        },
        routingNumber:{
            content: organization.paymentPreferences.routingNumber.value
        },
        approvalStatus:{
            visible: organization.paymentPreferences.approvalInProgress.value === true,
            content: translator(messages.depositApprovalPending)
        },
        editDirectDeposit: {
            visible: !(organization.paymentPreferences.approvalInProgress.value),
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {   
            addressSummaryComponent: AddressSummary              
        },
        resolveCallbackMap: {
            editPrimaryContactDetails,
            editPrimaryLocationAddressDetails,
            editMailingAddressDetails,
            editDirectDepositDetails
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={userVM}
            overrideProps={overrideProps}
            // onValueChange={handleSearchValueChange}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

OrgInfoTable.propTypes = {
    
};

OrgInfoTable.defaultProps = {

};

export default OrgInfoTable;
